var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "p",
    [
      _c(
        "el-popover",
        {
          attrs: { placement: "bottom", width: "400", trigger: "click" },
          on: {
            "after-enter": function ($event) {
              return _vm.getProcessPlateList(_vm.rowData["id"])
            },
          },
        },
        [
          _c(
            "el-table",
            {
              key: "process" + _vm.rowData["id"],
              attrs: {
                size: "mini",
                data: _vm.processPlateList,
                "header-cell-style": { background: "rgba(245,247,250,1)" },
              },
            },
            [
              _c("el-table-column", {
                attrs: { property: "overprintPicture", label: "主图片" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (process) {
                      return [
                        _c("img", {
                          attrs: {
                            width: "100",
                            src: _vm.imgPrefix + process.row.overprintPicture,
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { property: "overprintDesignNo", label: "套版SPU编码" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (process) {
                      return [_vm._v(_vm._s(process.row.overprintDesignNo))]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  property: "salesVolumesAndCostPrice",
                  label: "销售数量成本价",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (process) {
                      return [
                        _c("p", [_vm._v(_vm._s(process.row.salesVolumes))]),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(process.row.costPrice))]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  property: "plateStatusAndOrderStatus",
                  label: "打版状态下单状态",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (process) {
                      return [
                        _c("p", [_vm._v(_vm._s(process.row.plateStatus))]),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(process.row.orderStatus))]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  property: "overprintDesignerName",
                  label: "选款人设计师",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (process) {
                      return [
                        _c("p", [_vm._v(_vm._s(process.row.overprintPayer))]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(_vm._s(process.row.overprintDesignerName)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                "margin-right": "5px",
                "text-decoration": "underline",
                cursor: "pointer",
              },
              attrs: { slot: "reference" },
              slot: "reference",
            },
            [_vm._v(_vm._s(_vm.rowData["overprintDesignNo"]))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }